import React from "react";
import { MyContext } from "../../../context";
import { DefaultButton, PrimaryButton, TextField, Checkbox, ComboBox, Spinner } from "office-ui-fabric-react";
import {
    queryGetConfigData,
    mutationUpdateStorage,
    mutationCreateStorageAccount,
    checkStorageAccountName,
    queryGetAWSRegions,
    checkS3StorageConnection,
    getStorageData,
    checkCustomKeyVault,
    mutationCheckStorageIsUsed,
    mutationDeleteStorage,
} from "../../../queries/querySettings";
import { Query } from "react-apollo";
import { toast } from "react-toastify";
import SafetyDialog from "../../CustomComponents/SafetyDialog";

export default class AddStorageAccount extends React.Component {
    constructor(props) {
        super(props);
        this.allowEdit = true;
        if (this.props.data != null && this.props.data !== undefined) {
            this.state = {
                ...this.props.data,
                hideDialogDelete: true,
                hideDialogIsActive: true,
            };

            this.allowEdit = this.props.data.group === "custom" ? true : false;
        } else {
            this.state = {
                id: null,
                group: "custom",
                storageAccountName: "",
                visibleForAssignment: false,
                isActive: false,
                displayName: "",
                updated: false,
                validateStorageAccountName: "",
                awsAccessKeyId: "",
                awsSecretAccess: "",
                awsBucketName: "",
                awsRegion: "",
                s3Check: "",
                awsType: "",
                awsServiceUrl: "",
                storageLocation: "AzureBlobStorage",
                isSaving: false,
                useRegionalEncryption: false,
                keyVaultUrl: "",
                secretName: "",
                isAsymmetric: false,
                validateKeyVault: "",
                hideDialogDelete: true,
                hideDialogIsActive: true,
                disablePayloadSigning: false,
                archiving:"Nan"
            };
        }
    }
    styles = {
        root: {
            paddingTop: "20px",
        },
    };

    checkS3StorageConnection = async () => {
        this.setState({ s3Check: "pending" });
        document.getElementById("checkS3Btn").style.border = "";

        var data = await this.props.apol.mutate({
            mutation: checkS3StorageConnection,
            variables: {
                id: this.state.awsAccessKeyId,
                secret: this.state.awsSecretAccess,
                region: this.state.awsRegion,
                bucket: this.state.awsBucketName,
                awsServiceUrl: this.state.awsServiceUrl,
                awsType: this.state.awsType,
            },
        });
        if (data.data.checkS3StorageConnection) {
            document.getElementById("checkS3Btn").style.border = "2px solid green";
            this.setState({ s3Check: "true" });
        } else {
            document.getElementById("checkS3Btn").style.border = "2px solid red";
            this.setState({ s3Check: "false" });
        }
    };

    checkKeyVault = async () => {
        this.setState({ validateKeyVault: "pending" });

        var data = await this.props.apol.mutate({
            mutation: checkCustomKeyVault,
            variables: {
                customKeyVaultUrl: this.state.keyVaultUrl,
                customSecretName: this.state.secretName,
                isAsymmetric: this.state.isAsymmetric,
            },
        });
        switch (data.data.checkCustomKeyVault) {
            case 0: //accessible
                document.getElementById("keyVault").style.border = "1px solid green";
                document.getElementById("secretName").style.border = "1px solid green";
                document.getElementById("keyVaultError").innerHTML = "";
                document.getElementById("secretError").innerHTML = "";
                toast.success("Key Vault and secret name are correct", { autoClose: 5000, position: "bottom-left" });
                document.querySelector("#checkKeyVault").style.border = "1px solid green";
                this.setState({ validateKeyVault: "true" });
                break;
            case 1: //InvalidKeyVaultUrl
                document.getElementById("keyVaultError").innerHTML = "Key vault doesn't exist or permissions are not set";
                document.getElementById("keyVault").style.border = "1px solid red";
                toast.error("Key vault doesn't exist or permissions are not set", { autoClose: 5000, position: "bottom-left" });
                document.querySelector("#checkKeyVault").style.border = "1px solid red";
                this.setState({ validateKeyVault: "false" });

                break;
            case 2: //SecretNotFound
                document.getElementById("keyVaultError").innerHTML = "";
                document.getElementById("keyVault").style.border = "1px solid green";
                document.getElementById("secretError").innerHTML = "No key name was found";
                document.getElementById("secretName").style.border = "1px solid red";
                toast.error("No key name was found", { autoClose: 5000, position: "bottom-left" });
                document.querySelector("#checkKeyVault").style.border = "1px solid red";
                this.setState({ validateKeyVault: "false", showModal: "true" });

                break;
            case 3: //NoValidSecretVersion
                document.getElementById("keyVaultError").innerHTML = "";
                document.getElementById("keyVault").style.border = "1px solid green";
                document.getElementById("secretError").innerHTML =
                    "No valid version of the secret was found (secret has to be enabled, active and not expired)";
                document.getElementById("secretName").style.border = "1px solid red";
                toast.error("No valid version of the secret was found (secret has to be enabled, active and not expired)", {
                    autoClose: 5000,
                    position: "bottom-left",
                });
                document.querySelector("#checkKeyVault").style.border = "1px solid red";
                this.setState({ validateKeyVault: "false" });

                break;
            case 4: //IncorrectSecretContentType
                document.getElementById("keyVaultError").innerHTML = "";
                document.getElementById("keyVault").style.border = "1px solid green";
                document.getElementById("secretError").innerHTML =
                    "The content type of the secret is not correct, set the content type to 'application / octet - stream'";
                document.getElementById("secretName").style.border = "1px solid red";
                toast.error("The content type of the secret is not correct, set the content type to 'application / octet - stream'", {
                    autoClose: 5000,
                    position: "bottom-left",
                });
                document.querySelector("#checkKeyVault").style.border = "1px solid red";
                this.setState({ validateKeyVault: "false" });

                break;
            case 5: //IncorrectKeySize
                document.getElementById("keyVaultError").innerHTML = "";
                document.getElementById("keyVault").style.border = "1px solid green";
                document.getElementById("secretError").innerHTML = "The size of the key is invalid (valid sizes are 128, 192 or 256 bits)";
                document.getElementById("secretName").style.border = "1px solid red";
                toast.error("The size of the key is invalid (valid sizes are 128, 192 or 256 bits)", { autoClose: 5000, position: "bottom-left" });
                document.querySelector("#checkKeyVault").style.border = "1px solid red";
                this.setState({ validateKeyVault: "false" });

                break;
            case 6: //ForbiddenOperation
                document.getElementById("keyVaultError").innerHTML = "";
                document.getElementById("secretError").innerHTML = "";
                document.getElementById("secretName").style.border = "";
                document.getElementById("keyVault").style.border = "";
                toast.error("Access Denied", { autoClose: 5000, position: "bottom-left" });
                document.querySelector("#checkKeyVault").style.border = "1px solid red";
                this.setState({ validateKeyVault: "false" });

                break;
            case 7: //UnknownError
                document.getElementById("keyVaultError").innerHTML = "";
                document.getElementById("secretError").innerHTML = "";
                document.getElementById("secretName").style.border = "";
                document.getElementById("keyVault").style.border = "";
                toast.error("Unknown Error", { autoClose: 5000, position: "bottom-left" });
                document.querySelector("#checkKeyVault").style.border = "1px solid red";
                this.setState({ validateKeyVault: "false" });

                break;
            case 8: //InvalidKeyContentEncoding
                document.getElementById("keyVaultError").innerHTML = "Invalid encoding for the key content";
                document.getElementById("keyVault").style.border = "1px solid red";
                toast.error("Invalid encoding for the key content", { autoClose: 5000, position: "top-left" });
                document.querySelector("#checkKeyVault").style.border = "1px solid red";
                this.setState({ validateKeyVault: "false" });

                break;
        }
    };

    saveDisableCheck = () => {
        if (this.state.isSaving) {
            return true;
        } else {
            if (!this.state.isActive && !this.props.isEdit) {
                return true;
            } else {
                if (!this.allowEdit && this.state.updated) {
                    return false;
                } else {
                    if (this.state.storageLocation === "AzureBlobStorage") {
                        if (
                            this.state.updated &&
                            !(this.state.validateStorageAccount == "pending" || this.state.validateStorageAccount == "false") &&
                            !(this.state.validateKeyVault === "pending" || this.state.validateKeyVault === "false")
                        ) {
                            return false;
                        } else {
                            return true;
                        }
                    } else {
                        if (this.state.updated && this.state.s3Check == "true") {
                            return false;
                        } else {
                            return true;
                        }
                    }
                }
            }
        }
    };
    disbaledCheckValidity = () => {
        if (this.state.s3Check == "pending") {
            return true;
        }
        if (
            this.state.awsAccessKeyId !== "" &&
            this.state.awsAccessKeyId !== null &&
            this.state.awsSecretAccess !== "" &&
            this.state.awsSecretAccess !== null &&
            this.state.awsBucketName !== "" &&
            this.state.awsBucketName !== null
        ) {
            if (this.state.awsType === "Cloud" && this.state.awsRegion !== "" && this.state.awsRegion !== null) {
                return false;
            } else if (this.state.awsType === "OnPremise" && this.state.awsServiceUrl !== "" && this.state.awsServiceUrl !== null) {
                return false;
            }
        }
        return true;
    };
    checkStorageIsUsed = () => {
        this.setState({ processingCheck: true, showDeleteButton: false });
        this.props.apol
            .mutate({
                mutation: mutationCheckStorageIsUsed,
                variables: { storageId: this.props.data.id },
            })
            .then((result) => {
                this.setState({ storageIsUsed: result.data.checkStorageIsUsed, processingCheck: false });
            });
    };

    deleteStorage = async () => {
        var data = await this.props.apol.mutate({
            mutation: mutationDeleteStorage,
            refetchQueries: [
                {
                    query: queryGetConfigData,
                    variables: { auth: this.props.authorization },
                },
            ],
            variables: {
                storageId: this.props.data.id,
            },
        });
        if (data.data.deleteStorage) {
            toast.info(<MyContext.Consumer>{(context) => <> {context.getTranslation("configuration", "storageDeleted")}</>}</MyContext.Consumer>, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } else {
            toast.error(<MyContext.Consumer>{(context) => <> {context.getTranslation("configuration", "storageDeletedError")}</>}</MyContext.Consumer>, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
        this.props.cl();
    };
    render() {
        return (
            <MyContext.Consumer>
                {(context) => (
                    <>
                        <ComboBox
                            style={{ width: "300px" }}
                            placeholder="Select an option"
                            label={context.getTranslation("configuration", "storageLocation")}
                            options={[
                                { key: "AzureBlobStorage", text: "AzureBlobStorage" },
                                { key: "S3", text: "S3 Storage" },
                            ]}
                            selectedKey={this.state.storageLocation}
                            onChange={(ev, newVal) => {
                                this.setState({
                                    storageLocation: newVal.key,
                                    isAsymmetric: newVal.key === "S3" ? false : this.state.isAsymmetric,
                                    updated: true,
                                });
                            }}
                            disabled={!this.allowEdit ? true : this.props.data !== null ? true : false}
                        //If allow edit is false is disabeld by default
                        //If allow edit is true an fid data is null the field can be edited, otherwise not because cannot change a storage from s3 to blob and vice versa
                        />
                        <TextField
                            value={this.state.displayName}
                            label={context.getTranslation("configuration", "storageDisplayName")}
                            onChange={(event, newValue) => {
                                this.setState({ displayName: newValue, updated: true });
                            }}
                            styles={this.styles}
                            disabled={!this.allowEdit}
                        />
                        {this.state.storageLocation === "AzureBlobStorage" && (
                            <>
                                <TextField
                                    id="storageAccountName"
                                    value={this.state.storageAccountName}
                                    label={context.getTranslation("configuration", "customerStorageAccountName")}
                                    onChange={(event, newValue) => {
                                        this.setState({ storageAccountName: newValue, updated: true, validateStorageAccount: "false" });
                                    }}
                                    styles={this.styles}
                                    disabled={!this.allowEdit}
                                />
                                <span id="storageAccountNameError" style={{ color: "red" }}></span>
                                <br />
                                <DefaultButton
                                    id="checkBtn"
                                    text={<MyContext.Consumer>{(context) => <> {context.getTranslation("dashboard", "checkValidity")}</>}</MyContext.Consumer>}
                                    onClick={(event) => {
                                        this.checkStorageAccountName(this.props.apol);
                                    }}
                                    disabled={this.state.validateStorageAccount == "pending"}
                                />
                            </>
                        )}
                        {/*s3 fields*/}
                        {this.state.storageLocation === "S3" && (
                            <>
                                <ComboBox
                                    style={{ width: "300px" }}
                                    placeholder="Select an option"
                                    label={context.getTranslation("configuration", "awsType")}
                                    options={[
                                        { key: "Cloud", text: "Cloud" },
                                        { key: "OnPremise", text: "On-premise" },
                                    ]}
                                    selectedKey={this.state.awsType}
                                    onChange={(ev, newVal) => {
                                        this.setState({
                                            awsType: newVal.key,
                                            s3Check: "false",
                                            updated: true,
                                        });
                                    }}
                                    errorMessage={this.state.awsType == "" || this.state.awsType == null ? "Aws type must be selected" : ""}
                                />
                                <TextField
                                    type={"text"}
                                    label={context.getTranslation("configuration", "awsAccessKeyId")}
                                    value={this.state.awsAccessKeyId}
                                    errorMessage={this.state.awsAccessKeyId === "" || this.state.awsAccessKeyId === null ? "Access Key Id cannot be empty" : ""}
                                    onChange={(event, newValue) => {
                                        this.setState({
                                            awsAccessKeyId: newValue,
                                            s3Check: "false",
                                            updated: true,
                                        });
                                    }}
                                />
                                <TextField
                                    type={"text"}
                                    label={context.getTranslation("configuration", "awsSecretAccess")}
                                    value={this.state.awsSecretAccess}
                                    errorMessage={this.state.awsSecretAccess === "" || this.state.awsSecretAccess === null ? "Secret Access key cannot be empty" : ""}
                                    onChange={(event, newValue) => {
                                        this.setState({
                                            awsSecretAccess: newValue,
                                            s3Check: "false",
                                            updated: true,
                                        });
                                    }}
                                />
                                {this.state.awsType == "OnPremise" && (
                                    <TextField
                                        type={"text"}
                                        label={context.getTranslation("configuration", "awsServiceUrl")}
                                        value={this.state.awsServiceUrl}
                                        errorMessage={this.state.awsServiceUrl === "" || this.state.awsServiceUrl === null ? "Service Url cannot be empty" : ""}
                                        onChange={(event, newValue) => {
                                            this.setState({
                                                awsServiceUrl: newValue,
                                                s3Check: "false",
                                                updated: true,
                                            });
                                        }}
                                    />
                                )}
                                <TextField
                                    type={"text"}
                                    label={context.getTranslation("configuration", "awsBucketName")}
                                    value={this.state.awsBucketName}
                                    errorMessage={this.state.awsBucketName === "" || this.state.awsBucketName === null ? "Bucket name cannot be empty" : ""}
                                    onChange={(event, newValue) => {
                                        this.setState({
                                            awsBucketName: newValue,
                                            s3Check: "false",
                                            updated: true,
                                        });
                                    }}
                                />
                                {this.state.awsType == "OnPremise" && (<>
                                    <TextField
                                        type={"text"}
                                        label={context.getTranslation("configuration", "awsServiceUrl")}
                                        value={this.state.awsServiceUrl}
                                        errorMessage={this.state.awsServiceUrl === "" || this.state.awsServiceUrl === null ? "Service Url cannot be empty" : ""}
                                        onChange={(event, newValue) => {
                                            this.setState({
                                                awsServiceUrl: newValue,
                                                s3Check: "false",
                                                updated: true,
                                            });
                                        }}
                                    />
                                    <Checkbox
                                        checked={this.state.disablePayloadSigning}
                                        label={context.getTranslation("configuration", "disablePayloadSigning")}
                                        onChange={(event, newValue) => {

                                            this.setState({ disablePayloadSigning: newValue, updated: true });
                                        }}
                                        styles={this.styles}

                                    />

                                </>)}
                                {this.state.awsType === "Cloud" && (
                                    <Query query={queryGetAWSRegions} variables={this.props.authorization}>
                                        {({ loading, error, data }) => {
                                            if (loading)
                                                return (
                                                    <div>
                                                        <Spinner label={context.getTranslation("common", "loadingRegions")} ariaLive="assertive" labelPosition="top" />
                                                    </div>
                                                );
                                            if (error) return <h1> </h1>;

                                            if (data.getAWSRegions == null) {
                                                return <div></div>;
                                            }
                                            this.tmpKey = [];
                                            const stack = data.getAWSRegions;
                                            if (data.getAWSRegions != null) {
                                                for (let x = 0; x < stack.length; x++) {
                                                    let i = {
                                                        key: stack[x].code,
                                                        text: stack[x].displayName,
                                                    };
                                                    this.tmpKey.push(i);
                                                }
                                            }

                                            return (
                                                <ComboBox
                                                    style={{ width: "300px" }}
                                                    placeholder="Select an option"
                                                    label={context.getTranslation("configuration", "defaultRegion")}
                                                    options={this.tmpKey}
                                                    selectedKey={this.state.awsRegion}
                                                    onChange={(ev, newVal) => {
                                                        this.setState({
                                                            awsRegion: newVal.key,
                                                            s3Check: "false",
                                                            updated: true,
                                                        });
                                                    }}
                                                    errorMessage={this.state.awsRegion == "" || this.state.awsRegion == null ? "Default region must be selected" : ""}
                                                />
                                            );
                                        }}
                                    </Query>
                                )}
                                <br />
                                <DefaultButton
                                    id="checkS3Btn"
                                    text={context.getTranslation("dashboard", "checkValidity")}
                                    onClick={this.checkS3StorageConnection}
                                    disabled={this.disbaledCheckValidity()}
                                />
                            </>
                        )}

                        <Checkbox
                            checked={this.state.isActive}
                            label={context.getTranslation("configuration", "isActive")}
                            onChange={(event, newValue) => {
                                if (!newValue && this.props.isEdit) {
                                    this.setState({ isActive: newValue, visibleForAssignment: newValue, updated: true });
                                    this.setState({ hideDialogIsActive: false });
                                } else {
                                    this.setState({ isActive: newValue, updated: true });
                                }
                            }}
                            styles={this.styles}
                            disabled={
                                !this.allowEdit ||
                                (this.props.data &&
                                    this.props.data.defaultStorage === this.props.data.displayName)
                            }
                        />
                        <SafetyDialog
                            title={context.getTranslation("configuration", "activeStoragTitle")}
                            subText={context.getTranslation("configuration", "confirmDeactivateStorage")}
                            hideDialog={this.state.hideDialogIsActive}
                            closeDialog={() => {
                                this.setState({ hideDialogIsActive: true, isActive: true, visibleForAssignment: false, updated: false });
                            }}
                            ok={() => this.setState({ isActive: false, hideDialogIsActive: true })}
                        />

                        <Checkbox
                            checked={this.state.visibleForAssignment}
                            label={context.getTranslation("configuration", "visibleForAssignment")}
                            onChange={(event, newValue) => {
                                this.setState({ visibleForAssignment: newValue, updated: true });
                            }}
                            styles={this.styles}
                            disabled={
                                !this.allowEdit ||
                                (this.props.data &&
                                    this.props.data.defaultStorage === this.props.data.displayName)
                            }
                        />
                        {(this.state.storageLocation === "AzureBlobStorage" || this.state.storageLocation === "ASC") && this.state.archiving !== "Nan" &&
                            <Checkbox
                                checked={this.state.archiving === "True"}
                                label={context.getTranslation("configuration", "archiving")}
                                onChange={(event, newValue) => {
                                    this.setState({ archiving: newValue ? "True" : "False", updated: true });
                                }}
                                styles={this.styles}
                                disabled={!this.props.tenantData?.audioStorage?.archiveBlobs}
                            />
                        }

                        <Checkbox
                            checked={this.state.useRegionalEncryption}
                            label={context.getTranslation("configuration", "keyVault")}
                            onChange={(event, newValue) => {
                                this.setState({
                                    useRegionalEncryption: newValue,
                                    updated: true,
                                    validateKeyVault: newValue ? "false" : "",
                                });
                            }}
                            styles={this.styles}
                            disabled={!this.allowEdit}
                        />
                        {this.state.useRegionalEncryption && (
                            <>
                                <TextField
                                    id="keyVault"
                                    value={this.state.keyVaultUrl}
                                    label={context.getTranslation("configuration", "keyVaultUrl")}
                                    onChange={(event, newValue) => {
                                        this.setState({ keyVaultUrl: newValue, validateKeyVault: "false", updated: true });
                                    }}
                                    styles={this.styles}
                                    disabled={!this.allowEdit}
                                />
                                <span id="keyVaultError" style={{ color: "red" }}></span>

                                <TextField
                                    id="secretName"
                                    value={this.state.secretName}
                                    label={context.getTranslation("configuration", "keyName")}
                                    onChange={(event, newValue) => {
                                        this.setState({ secretName: newValue, validateKeyVault: "false", updated: true });
                                    }}
                                    styles={this.styles}
                                    disabled={!this.allowEdit}
                                />
                                <span id="secretError" style={{ color: "red" }}></span>

                                <Checkbox
                                    checked={this.state.isAsymmetric}
                                    label={context.getTranslation("tenants", "asymmetricKeyEnabled")}
                                    onChange={(event, newValue) => {
                                        this.setState({ isAsymmetric: newValue, validateKeyVault: "false", updated: true });
                                    }}
                                    styles={this.styles}
                                    disabled={!this.allowEdit || this.state.storageLocation === "S3"}
                                />
                                <br />

                                <DefaultButton
                                    id="checkKeyVault"
                                    text={context.getTranslation("dashboard", "checkValidity")}
                                    onClick={this.checkKeyVault}
                                    disabled={this.state.validateKeyVault === "pending"}
                                />
                            </>
                        )}

                        <div style={{ paddingTop: "20px" }}>
                            <PrimaryButton
                                onClick={(event) => this.notifyStorageChange(this.props.apol)}
                                text={context.getTranslation("common", "save")}
                                disabled={this.saveDisableCheck()}
                                style={{ marginRight: "10px" }}
                            />
                            <DefaultButton
                                onClick={(event) => {
                                    this.props.cl();
                                }}
                                text={context.getTranslation("common", "cancel")}
                                style={{ marginRight: "10px" }}
                            />

                            {this.props.isEdit && this.props.data.storageType !== "ASC" && (
                                <>
                                    {(this.state.showDeleteButton || this.state.showDeleteButton == undefined) && (
                                        <DefaultButton
                                            data-automation-id="test"
                                            text={context.getTranslation("configuration", "checkIfStorageUsed")}
                                            allowDisabledFocus={true}
                                            onClick={this.checkStorageIsUsed}
                                        />
                                    )}
                                    {this.state.processingCheck && (
                                        <DefaultButton data-automation-id="test" text={context.getTranslation("common", "loading")} allowDisabledFocus={true} disabled />
                                    )}
                                    {this.state.storageIsUsed == false && (
                                        <>
                                            <DefaultButton
                                                data-automation-id="test"
                                                style={{ background: "red", color: "white" }}
                                                text={context.getTranslation("configuration", "deleteStorage")}
                                                allowDisabledFocus={true}
                                                onClick={() => {
                                                    this.setState({ hideDialogDelete: false });
                                                }}
                                            />
                                            <SafetyDialog
                                                title={context.getTranslation("configuration", "deleteStorageTitle")}
                                                subText={context.getTranslation(
                                                    "configuration",
                                                    this.state.storageLocation === "S3" ? "confirmDeleteS3Storage" : "confirmDeleteStorage"
                                                )}
                                                hideDialog={this.state.hideDialogDelete}
                                                closeDialog={() => {
                                                    this.setState({ hideDialogDelete: true });
                                                }}
                                                ok={this.deleteStorage}
                                            />
                                        </>
                                    )}

                                    {this.state.storageIsUsed == true && (
                                        <DefaultButton
                                            data-automation-id="test"
                                            text={context.getTranslation("configuration", "unableToDeleteStorage")}
                                            allowDisabledFocus={true}
                                            disabled
                                        />
                                    )}
                                </>
                            )}
                        </div>
                    </>
                )}
            </MyContext.Consumer>
        );
    }

    notifyStorageChange = async (apol) => {
        //Add or change storage
        this.setState({ isSaving: true });
        var storage;

        storage = {
            id: this.state.id,
            group: this.state.group,
            storageAccountName: this.state.storageAccountName,
            visibleForAssignment: this.state.visibleForAssignment,
            isActive: this.state.isActive,
            displayName: this.state.displayName,
            awsAccessKeyId: this.state.awsAccessKeyId,
            awsSecretAccess: this.state.awsSecretAccess,
            awsBucketName: this.state.awsBucketName,
            awsRegion: this.state.awsRegion,
            awsType: this.state.awsType,
            awsServiceUrl: this.state.awsServiceUrl,
            storageLocation: this.state.storageLocation,
            useRegionalEncryption: this.state.useRegionalEncryption,
            keyVaultUrl: this.state.keyVaultUrl,
            secretName: this.state.secretName,
            isAsymmetric: this.state.isAsymmetric,
            disablePayloadSigning: this.state.disablePayloadSigning,
            archiving: this.state.archiving

        };
        if (this.props.data != null) {
            var data = await apol.mutate({
                mutation: mutationUpdateStorage,
                refetchQueries: [
                    {
                        query: queryGetConfigData,
                        variables: { auth: this.props.authorization },
                    },
                ],
                variables: {
                    auth: this.props.authorization,
                    storage: storage,
                },
            });
            if (data.data.updateStorage == null) {
                toast.error(
                    <MyContext.Consumer>{(context) => <> {context.getTranslation("configuration", "editStorageNotSuccessfull")}</>}</MyContext.Consumer>,
                    {
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    }
                );
            } else {
                toast.success(<MyContext.Consumer>{(context) => <> {context.getTranslation("configuration", "storageChanged")}</>}</MyContext.Consumer>, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }
        } else {
            data = await apol.mutate({
                mutation: mutationCreateStorageAccount,
                refetchQueries: [
                    {
                        query: queryGetConfigData,
                        variables: { auth: this.props.authorization },
                    },
                ],
                variables: {
                    auth: this.props.authorization,
                    storage: storage,
                },
            });

            if (data.data.createStorage == null) {
                toast.error(
                    <MyContext.Consumer>{(context) => <> {context.getTranslation("configuration", "addStorageNotSuccessfull")}</>}</MyContext.Consumer>,
                    {
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    }
                );
            } else {
                toast.success(<MyContext.Consumer>{(context) => <> {context.getTranslation("configuration", "storageAdded")}</>}</MyContext.Consumer>, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }
        }
        this.props.cl();
    };

    checkStorageAccountName = async (apol) => {
        this.setState({ validateStorageAccount: "pending" });

        document.getElementById("storageAccountName").style.border = "";
        document.getElementById("storageAccountNameError").innerHTML = "";
        document.querySelector("#checkBtn").style.border = "";

        var data = await apol.mutate({
            mutation: checkStorageAccountName,
            variables: {
                storageAccountName: this.state.storageAccountName,
            },
        });

        if (data.data.checkStorageAccountName == true) {
            document.getElementById("storageAccountName").style.border = "1px solid green";
            document.getElementById("storageAccountNameError").innerHTML = "";
            toast.success("Storage account name is valid", { autoClose: 5000, position: "bottom-left" });
            document.querySelector("#checkBtn").style.border = "1px solid green";
            this.setState({ validateStorageAccount: "true" });
        } else {
            document.getElementById("storageAccountName").style.border = "1px solid red";
            document.getElementById("storageAccountNameError").innerHTML = "Storage account name is not valid";
            toast.error("Storage account name is not valid", { autoClose: 5000, position: "bottom-left" });
            document.querySelector("#checkBtn").style.border = "1px solid red";
            this.setState({ validateStorageAccount: "false" });
        }
    };
}
